import { render, staticRenderFns } from "./panel.vue?vue&type=template&id=a02da39c&"
import script from "./panel.vue?vue&type=script&lang=js&"
export * from "./panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a02da39c')) {
      api.createRecord('a02da39c', component.options)
    } else {
      api.reload('a02da39c', component.options)
    }
    module.hot.accept("./panel.vue?vue&type=template&id=a02da39c&", function () {
      api.rerender('a02da39c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/collapse/panel.vue"
export default component.exports